import { render, staticRenderFns } from "./FAQComponent.vue?vue&type=template&id=b075d92c&scoped=true&"
import script from "./FAQComponent.vue?vue&type=script&lang=js&"
export * from "./FAQComponent.vue?vue&type=script&lang=js&"
import style0 from "./FAQComponent.vue?vue&type=style&index=0&id=b075d92c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b075d92c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VExpansionPanels,VRow})
